import { CurrencyISO } from '@guiker/money'
import { yup } from '@guiker/yup-util'

export const createFundingAccountSchema = yup.object({
  userId: yup.string().required(),
  currency: yup.string().oneOf([CurrencyISO.CAD]).required(),
})
